const config = () => ({
  appName: 'news-web',
  gtm: {
    id: 'GTM-T3MW3GR',
  },
  ga: {
    id: 'UA-54102511-26',
  },
  optimize: {
    id: 'GTM-PCS5LP3',
  },
  comscore: {
    publisherId: '28229342',
    brand: 'Blick',
    brand___romandie: 'Blick | fr',
    site: 'blick.ch',
    site___romandie: 'blick.ch/fr',
  },
  cookieNameOptOut: '_stg_optout',
  impressionThreshold: 500,
  metadataFields: [
    'articleFeatures',
    'author',
    'context',
    'contextId',
    'creator',
    'firstPublishedDate',
    'has360',
    'hasInfografik',
    'hasLivescore',
    'hasLivestream',
    'hasLiveticker',
    'hasSlideshow',
    'hasPlaylist',
    'hasText',
    'hasVideo',
    'id',
    'isSobli',
    'lastModifiedDate',
    'sectionUniqueNames',
    'tags',
    'teaserTitle',
    'thirdPartyId',
    'title',
  ],
})

export type configType = ReturnType<typeof config>
export default config
